import { Component, OnInit } from '@angular/core';
import { ModalBase, language, modal } from 'curvy';
import { Task } from '@task-utils/types';
import { files } from '@task-utils/utils';
import { TaskRoutes } from '@task-utils/routes';
import { users_translations } from '../users/users.trans';

@Component({
	selector: 'task-admin-manuals-dialog',
	template: `
		<div style="display: flex; flex-flow: column nowrap; height: 100%">
			<h2>Edit user manuals</h2>

			<div style="flex: 1; overflow: auto">
				General manual
				<div style="display: flex; flex-flow: row nowrap">
					<task-upload-files
						style="margin-top: -1.5em"
						button-label="Upload"
						[(ngModel)]="mapping[0]"
						(ngModelChange)="on_file('0', $event)"
					/>
				</div>


				@for (ut of user_type_entries; track ut[0]) {
					{{('USER.TYPE.' + ut[1]) | trans}}
					<div style="display: flex; flex-flow: row nowrap">
						<label class="checkbox-input pointer">
							<input type="checkbox" [(ngModel)]="no_manual_mapping[ut[0]]">
							<span style="margin-left:.3em;">NONE</span>
						</label>

						<task-upload-files
							style="margin-top: -1.5em"
							button-label="Upload"
							[style.opacity]="no_manual_mapping[ut[0]] ? 0.2 : 1"
							[style.pointer-events]="no_manual_mapping[ut[0]] ? 'none' : null"
							[(ngModel)]="mapping[ut[0]]"
							(ngModelChange)="on_file(ut[0], $event)"
						/>
					</div>
				}
			</div>

			<div style="display: flex; flex-flow: row nowrap; justify-content: space-between">
				<button (click)="on_cancel()" [disabled]="going">
					Cancel
				</button>

				<button class="filled" color="secondary" (click)="on_save()" [disabled]="going">
					Save
				</button>
			</div>
		</div>
	`,
})
export class AdminManualsDialog extends ModalBase<number, any> {
	preventSoftClose = true;
	user_type_entries = Object.entries(Task.User_Type);

	no_manual_mapping: Record<Task.USER_TYPE, boolean> = (() => {
		let out = {} as any;
		for (let entry of this.user_type_entries) {
			out[entry[0]] = false;
		}
		return out;
	})();

	mapping: Record<Task.USER_TYPE|0, []|[files.IFile]> = (() => {
		let out = {} as any;
		for (let entry of this.user_type_entries) {
			out[entry[0]] = [];
		}
		return out;
	})();

	ngOnInit() {
		language.load_translations(users_translations);
	}

	on_file(ut: string, arr: files.IFile[]) {
		if (arr.length > 1) {
			this.mapping[ut] = [arr.pop()];
		}
	}

	going = false;
	async on_save() {
		this.going = true;
		let out: Partial<Record<Task.USER_TYPE|0, string>> = {};

		let proms: Promise<any>[] = [];
		for (let ut in this.mapping) {
			if (this.no_manual_mapping[ut]) {
				out[ut] = "";
				continue;
			}

			let manuals = this.mapping[ut as "0"];
			if (manuals.length==0) continue;

			let man = manuals[0];
			let utt = ut;
			proms.push(
				TaskRoutes.upload.api_upload_file(man.file).then(res => {
					out[utt] = TaskRoutes.upload.uploaded_file_get(res.data);
				})
			);
		}

		await Promise.all(proms);
		await TaskRoutes.companies.api_company_set_manuals(this.injectedData, out);
		modal.close();
	}

	on_cancel() {
		modal.close();
	}
}
